module.exports = __webpack_public_path__ + "static/media/quiz-desk.330998e0.png";